import {useContext, useEffect, useRef} from 'react'
import VehiclesTable from '../antd/vehicle/VehicleTable'
import {getRequest} from '../services/base'
import {useSearchParams} from 'react-router-dom'
import {NavContext} from '../context/global_context'
import {PageHeaders} from '../config/PageHeaders'
import {deleteSessionStorage, setSessionStorageData,} from '../utils/SessionStorage'
import {useVehicles} from '../context/vehicle_context'
import {useIntl} from 'react-intl'
import { notifyError } from '../utils/notifications'

const Vehicle = () => {
  const intl = useIntl()
  const [value, dispatch] = useContext(NavContext)
  const [searchParams] = useSearchParams()
  const { vehicles, setVehiclesData, pagination, setPagination, setLoading } = useVehicles()
  const searchQuery = searchParams.get('search') || ''
  const currentUrl = useRef(`/api/vehicles/?search=${searchQuery}`)

  const setFilterValues = () => {
    let queryParams = {}
    searchParams.forEach((value, key) => {
      queryParams[key] = value
    })
    setSessionStorageData('vehicle', queryParams)
  }

  useEffect(() => {
    currentUrl.current = `/api/vehicles/?search=${searchQuery}`

    dispatch({
      type: 'header',
      data: {
        header: intl.formatMessage({ id: PageHeaders.vehicle.header }),
        sub_header: intl.formatMessage({ id: PageHeaders.vehicle.sub_header }),
        show_back_btn: false,
        dtc_details: {},
        full_width_container: false,
      },
    })
    setFilterValues()

    deleteSessionStorage('dtcs_list')
    getVehicles()

    return () => {
      setFilterValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery])

  const getVehicles = async () => {
    setLoading(true)
    try {
      let response = await getRequest(currentUrl.current)
      setVehiclesData(response.results)
      if (response?.status === false) {
        notifyError(dispatch, intl.formatMessage({ id: 'vehicleTable.loadError' }))
      }
      setPagination(response.pagination)
    } finally {
      setLoading(false)
    }
  }

  return (
    vehicles &&
    pagination && (
      <VehiclesTable
        pagination={pagination}
        getPaginatedData={(url) => {
          if (url) {
            currentUrl.current = url
          }
          getVehicles()
        }}
      />
    )
  )
}

export default Vehicle
